import { inclusions } from '../data/site';

export function Includes() {
  return (
    <section className="bg-cream-soft py-20 sm:py-24">
      <div className="container-content section-pad">
        <div className="text-center">
          <p className="eyebrow eyebrow--center">What Every Experience Includes</p>
          <h2 className="mt-4 font-display text-[clamp(2rem,4.5vw,3.25rem)] font-medium text-charcoal">
            Luxury, from pick-up to print
          </h2>
        </div>

        <div className="mt-14 grid grid-cols-2 gap-y-12 lg:grid-cols-4 lg:divide-x lg:divide-charcoal/10">
          {inclusions.map(({ label, Icon }) => (
            <div key={label} className="flex flex-col items-center px-4 text-center">
              <Icon className="h-9 w-9 text-crimson" strokeWidth={1.4} />
              <p className="mt-4 max-w-[10rem] font-sans text-[0.72rem] font-medium uppercase tracking-wide2 text-charcoal/75">
                {label}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
